import qs from 'qs';
import request from '@/config/request';

/*
  获取门店列表
  shopName
*/
export function getShopList({ page, pageSize, ...rest }) {
  return request({
    url: `/shop/getShopList?page=${page}&pageSize=${pageSize}`,
    method: 'post',
    data: qs.stringify(rest),
  });
}

/*
  获取会员列表
  userPhone
*/
export function getShopUserList(userPhone) {
  return request({
    url: '/shop/getShopUserList',
    method: 'post',
    data: qs.stringify({ userPhone }),
  });
}

/*
  添加门店
  shopName, shopAddress，shopLat，shopLong，shopPhone，shopQrCode，userIds
*/
export function addShop(rest) {
  return request({
    url: '/shop/addShop',
    method: 'post',
    data: qs.stringify(rest),
  });
}

/*
  删除门店
  id
*/
export function deleteShop(id) {
  return request({
    url: '/shop/deleteShop',
    method: 'post',
    data: qs.stringify({ id }),
  });
}

/*
  获取门店详情
  id
*/
export function getShopAndUser(id) {
  return request({
    url: '/shop/getShopAndUser',
    method: 'post',
    data: qs.stringify({ id }),
  });
}

/*
  编辑门店
  id，shopName, shopAddress，shopLat，shopLong，shopPhone，shopQrCode，userIds
*/
export function updateShop(rest) {
  return request({
    url: '/shop/updateShop',
    method: 'post',
    data: qs.stringify(rest),
  });
}
